import React, { useCallback, useState } from 'react'
import { useMount } from 'react-use'
import * as apis from '@/apis'
import { Spin, Button } from 'antd'
import { saveAs } from 'file-saver';
import dayjs from 'dayjs'
import styles from './summary.module.scss'

export default function FinancesSummary(props) {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const downloadFile = useCallback(() => {
    const month = dayjs().subtract(1, 'months').format('YYYY-MM')
    saveAs(apis.downloadWorkerPayroll(), `${month} - payroll.csv`)
  })

  useMount(() => {
    apis.getFinancesSummary()
      .then(result => {
        setLoading(false)
        setData(result)
      })
  })

  return (
    <Spin spinning={loading}>
      <div className={styles.summary}>
        <div className={styles.item}>
          <div className={styles.itemTitle}>工单总数</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data ? data.totalOrderCount : '-'}</div>
            <div className={styles.suffix}>单</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>正在进行中</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data ? data.processedOrderCount : '-'}</div>
            <div className={styles.suffix}>单</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>已取消</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data ? data.canceledOrderCount : '-'}</div>
            <div className={styles.suffix}>单</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>已出账单总计</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data ? data.totalBilledAmount?.toFixed(2) : '-'}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>待核对账单</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data ? data.unCheckedBillCount : '-'}</div>
            <div className={styles.suffix}>条</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>未出账单总计</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data?.totalUnbilledAmount?.toFixed(2) || '-'}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>剩余保证金总额度</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>{data?.baozhengTotal?.toFixed(2) || '-'}</div>
            <div className={styles.suffix}>元</div>
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.itemTitle}>师傅工资表</div>
          <div className={styles.itemBody}>
            <div className={styles.value}>
              <Button size="small" icon="download" onClick={downloadFile}>下载</Button>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  )
}
